import { StyledButton, StyledContainer } from "./Button.styles";

export const Button = ({ ...props }) => {
  return (
    <StyledContainer>
      <StyledButton disabled={props.disabled}>{props.children}</StyledButton>
    </StyledContainer>
  );
};
